
import { Ref, forwardRef, useEffect, useRef, useState } from 'react';

import { InputWrapper } from './InputGroup';
import { Span } from './Generic';
import DebouncedInput, { DebouncedInputProps } from './DebouncedInput';
import useCurrencies from '../useCurrencies';
import useCurrencyInput from '../useCurrencyInput';
import useLocale from '../useLocale';

const CurrencyInput = forwardRef(({
  style, id: idProp, ...props
}: DebouncedInputProps, ref: Ref<HTMLInputElement>) => {
  const { getCurrencySymbol } = useCurrencies();
  const { currency } = useLocale();
  const currencyInput = useCurrencyInput();

  const idRef = useRef(`CurrencyInput_${Math.round(Math.random() * 1000000)}`);
  const id = idProp || idRef.current;

  const labelRef = useRef<HTMLLabelElement>(null);
  const [paddingLeft, setPaddingLeft] = useState(40);

  useEffect(() => {
    if (labelRef.current) {
      setPaddingLeft(labelRef.current.clientWidth);
    }
  }, [currency]);

  return (
    <InputWrapper>
      <label ref={labelRef} htmlFor={id}>
        <Span sc={{ color: props.sc?.color, muted: props.disabled }}>
          {getCurrencySymbol(currency)}
        </Span>
      </label>
      <DebouncedInput
        id={id}
        style={{ paddingLeft, ...style }}
        placeholder={currencyInput.value(0)}
        format={currencyInput.format}
        match={currencyInput.match}
        {...props}
        ref={ref}
      />
    </InputWrapper>
  );
});

export default CurrencyInput;
